// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__esU+r","spinner":"LoadingSpinner_spinner__O6jfG","spin":"LoadingSpinner_spin__xnPWq","message":"LoadingSpinner_message__hrP7g"};